module.exports = __webpack_public_path__ + "img/vafler.abcda5a4.jpg";